import { ApolloLink, HttpLink } from '@apollo/client'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { fetch } from '../utils/fetch-wrapper.js'
import { isTestEnv } from '../utils/is-test-env'

export const SINGER_SERVICE = 'singer'

export const createHttpLink = function createHttpLink() {
  /* NOTE: BatchHttpLink won't work in tests, so we will use regular HttpLink when we are in a test
     Tests also require a fetch method to be defined
  */

  // enterprise-graphql
  const options = {
    uri: isTestEnv() ? 'http://localhost/api/graphql' : '/ent-api/graphql',
    ...(isTestEnv() && fetch),
    headers: { 'client-name': 'ent-web' },
  }
  const httpLink = isTestEnv() ? new HttpLink(options) : new BatchHttpLink(options)

  // singer
  const singerOptions = {
    uri: isTestEnv() ? 'http://localhost/api/graphql' : '/ent-api/singer/graphql',
    headers: { 'client-name': 'ent-web' },
  }
  const singerLink = isTestEnv() ? new HttpLink(singerOptions) : new BatchHttpLink(singerOptions)

  return ApolloLink.split((operation) => operation.getContext().service === SINGER_SERVICE, singerLink, httpLink)
}
